import {
  SUGGESTED_FILTERS_CONSOLIDATION_EXPERIMENT,
  SUGGESTED_FILTERS_CONSOLIDATION_TREATMENT_BUCKETS
} from '~/constants/srp/suggestedFiltersConsolidation';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import useExperimentBucket from '~/hooks/common/experiments/useExperimentBucket';
import type { SuggestedFilterTreatment } from '~/utilities/srp/suggestedFilterRange';

type ReturnType = {
  isAround: boolean;
  isLimit: boolean;
  isSplit: boolean;
  isStandard: boolean;
  shouldConsolidate: boolean;
  treatment: SuggestedFilterTreatment;
};

export default function useSuggestedFiltersConsolidationExperiment(): ReturnType {
  const bucket = useExperimentBucket(
    SUGGESTED_FILTERS_CONSOLIDATION_EXPERIMENT
  );
  const showComposerTreatment = useShowComposerTreatment();
  const isInExperiment =
    SUGGESTED_FILTERS_CONSOLIDATION_TREATMENT_BUCKETS.includes(bucket);
  const [placement, layout] = isInExperiment ? bucket.split('-') : [];
  const isAround = isInExperiment && placement === 'around';

  return {
    isAround,
    isLimit: isInExperiment && placement === 'limit',
    isSplit: isInExperiment && layout === 'split',
    isStandard: isInExperiment && layout === 'standard',
    shouldConsolidate: isInExperiment && !showComposerTreatment,
    treatment: isAround ? 'around' : 'limit'
  };
}
